// src/services/NewsSeenService.ts
import { doc, getDoc, updateDoc, Timestamp } from 'firebase/firestore';
import { firestore } from '../config/firebase';
import { toDate } from '../types/updates';

/**
 * When this account last looked at the news.
 *
 * Stored on `users/{uid}` rather than on a character, because news is not world-specific and
 * an account with three characters should not be told the same thing three times.
 *
 * `firestore.rules` lets the owner write their own `users` document freely except `pollid`,
 * so this needs no callable. It is a convenience marker: the worst case if it fails is that a
 * player is told "3 new" twice, which is why every path here swallows its errors rather than
 * surfacing them on the landing page.
 */

const FIELD = 'lastNewsSeenAt';

export const readNewsSeenAt = async (uid: string): Promise<Date | null> => {
    try {
        const snap = await getDoc(doc(firestore, 'users', uid));
        return snap.exists() ? toDate(snap.data()[FIELD]) : null;
    } catch (error) {
        console.error('Could not read the news marker:', error);
        return null;
    }
};

export const markNewsSeen = async (uid: string): Promise<void> => {
    try {
        await updateDoc(doc(firestore, 'users', uid), { [FIELD]: Timestamp.now() });
    } catch (error) {
        console.error('Could not move the news marker:', error);
    }
};
